import {
    GET_ALL_FORMS,
    GET_FORM_BY_ID,
    CREATE_FORM,
    UPDATE_FORM_BY_ID,
    DELETE_FORM_BY_ID,
    CREATE_LIST_FORM,
    FORM_ERROR
} from '../action/form';

const initialState = {
    forms: [],
    form: null,
    error: null,
};

const formReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_ALL_FORMS:
            return {
                ...state,
                forms: payload,
                error: null,
            };
        case GET_FORM_BY_ID:
            return {
                ...state,
                form: payload,
                error: null,
            };
        case CREATE_FORM:
            return {
                ...state,
                forms: [...state.forms, payload],
                error: null,
            };
        case CREATE_LIST_FORM:
            return {
                ...state,
                forms: [...state.forms, ...payload],
                error: null,
            };
        case UPDATE_FORM_BY_ID:
            return {
                ...state,
                forms: state.forms.map(form =>
                    form.id === payload.id ? payload : form
                ),
                error: null,
            };
        case DELETE_FORM_BY_ID:
            return {
                ...state,
                forms: state.forms.filter(form => form.id !== payload),
                error: null,
            };
        case FORM_ERROR:
            return {
                ...state,
                error: payload,
            };
        default:
            return state;
    }
};

export default formReducer;
